























import Vue from 'vue';
import Component from 'vue-class-component';
import { ChecklistItem } from '../shared/types/checklist-item.model';
import { Prop } from 'vue-property-decorator';

// The @Component decorator indicates the class is a Vue component
@Component({})
export default class Checklist extends Vue {
  @Prop()
  items!: ChecklistItem[];
}
